<!-- 注册 -->
<template>
    <div>
      <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
        <navcon></navcon>
      </div>
      <div class="index-page"></div>
      <div class="main-con html">
        <img style="width: 100%;" :src="url">
      </div>

      <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
        <footers></footers>
      </el-footer>
    </div>
      
  </template>
  <script type="text/ecmascript-6">
  import navcon from '../../components/navcon.vue'
  import footers from '../../components/footers.vue'
  export default {
    name: 'text',
    components: {
      navcon,
      footers,
    },
    data() {
      return {
        src:''
      }
    }
  }
  </script>
  
  <style scoped>
      .html{
        padding: 40px;
      }
  </style>


// WEBPACK FOOTER //
// src/views/certificate/text.vue